import createUploadObjWeb from "./createUploadObjWeb";
export default createUploadObjWeb;